import { TOGGLE_HEADER_PIN, SET_HEADER_PIN_STATE } from "../actions/types";

const initialState = {
  pinnedPages: {},
};

const headerPinReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_HEADER_PIN:
      return {
        ...state,
        pinnedPages: {
          ...state.pinnedPages,
          [action.payload.pathname]:
            !state.pinnedPages[action.payload.pathname],
        },
      };

    case SET_HEADER_PIN_STATE:
      return {
        ...state,
        pinnedPages: {
          ...state.pinnedPages,
          [action.payload.pathname]: action.payload.isPinned,
        },
      };

    default:
      return state;
  }
};

export default headerPinReducer;
